import Button from "./button";
import logo from '../assets/logo.svg';
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="border-b p-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
            {/* Logo à esquerda */}
            {/* <div className="text-white text-2xl font-bold"> */}
                <a href="/">
                    <img src={logo} ant="LucroTech" className="w-32" />
                </a>
            {/* </div> */}

            {/* Opções de navegação */}
            {/* <div className="hidden md:flex space-x-6">
                <a href="/" className="text-white hover:text-gray-300">Home</a>
                <a href="/about" className="text-white hover:text-gray-300">About</a>
                <a href="/services" className="text-white hover:text-gray-300">Services</a>
                <a href="/contact" className="text-white hover:text-gray-300">Contact</a>
            </div> */}

            {/* Botão de login à direita */}
            <div className="flex items-center space-x-4">
                <Link to="/login">
                    <Button color="primary" variant="contained" size="large">Login</Button>
                </Link>
            </div>
        </div>
    </nav>
  );
};

export default Navbar;
